// 全局弹泡
import os from '@edu-fe/os'
import api from '@edu-fe/api'
import * as get from '@ccforeverd/tool-get'

const name = 'popup'

export default {
  name,
  namespaced: false,

  state: {
    data: [],
    hasShow: false,
    storageName: 'global-popup-show-data',
    storageDelimiter: ';;'
  },

  getters: {
    popupShowData (state, getters, globalState) {
      const { data } = state
      const { route: { path } } = globalState
      const positionMap = {
        '0': '/', // 全部
        '1': '/today',
        '2': '/recommend',
        '3': '/mine'
      }

      for (let i = 0; i < data.length; i++) {
        if (path.indexOf(positionMap[data[i].position]) === 0) {
          return data[i] // 返回第一个
        }
      }
    },

    popupImgUrl (state, getters) {
      // 已展示过
      if (state.hasShow) {
        return ''
      }

      // 有可展示的课
      if (getters.popupShowData) {
        // 在历史记录中检索该过程
        if (state.storage.filter(id => id === String(getters.popupShowData ? getters.popupShowData.id : '')).length) {
          return ''
        }

        // 展示该课程
        return getters.popupShowData.image
      }

      // 没有可展示的课
      return ''
    }
  },

  mutations: {
    setPopupData (state, data) {
      const { client } = get.query()
      const clientMap = {
        '1': false, // PC端
        '2': typeof client === 'undefined' || parseInt(client) === 2, // 移动端
        '10': parseInt(client) === 10
      }
      const subClientMap = {
        '200': true,
        '201': os.type === 'weixin',
        '202': os.type === 'app'
      }

      state.data = data
        .filter(item => clientMap[item.client]) // 选取移动端
        .filter(item => subClientMap[item.subClient]) // 选取终端
    },

    setPopupStorage (state, data) {
      state.storage = data
    },

    setClosePopup (state) {
      state.hasShow = true
    }
  },

  actions: {
    // 获取数据 进入页面时调用
    async getPopupData ({ state, commit, rootState }) {
      const { client } = get.query()

      const { data } = await api.utils.pop({
        client: typeof client === 'undefined' ? 2 : client
      })
      commit('setPopupData', data)

      const storage = window.localStorage
      const { storageName: name, storageDelimiter: delimiter } = state
      const saveData = (storage.getItem(name) || '').split(delimiter)
      commit('setPopupStorage', saveData)
    },

    // 保存 id<list>
    async savePopupData ({ state, getters, commit }) {
      const storage = window.localStorage
      const { storageName: name, storageDelimiter: delimiter } = state
      const { popupShowData: { id: targetId } } = getters
      const saveData = (storage.getItem(name) || '').split(delimiter)

      if (saveData.filter(id => id === String(targetId)).length) {
        return
      }

      saveData.push(targetId)
      commit('setPopupStorage', saveData)
      storage.setItem(name, saveData.join(delimiter))
    },

    // 关闭弹框
    async closePopup ({ commit, dispatch }) {
      commit('setClosePopup')
      dispatch('savePopupData')
    }
  }
}
